import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import { useDispatch, useSelector } from 'react-redux';
import type { ChatPost } from '../../stores/types/chat';
import Socket from '../../connection/socket';
import { ConnectedUser } from '../../stores/types/connection';
import Avatar from '../general-components/avatar';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import { GreenroomState as GS } from '../../stores/types/types';
import { MODAL_TEMPLATES } from '../../stores/reducers/modal';
import * as ModalActions from '../../stores/actions/modal';
import useProfile from '../../hooks/use-profile';
interface ChatMessageProps {
	post: ChatPost;
	user?: ConnectedUser;
	isChild?: boolean | null;
	socket: Socket | null;
}

function parseDate(date: number | string): string {
	return new Date(date || Date.now()).toLocaleTimeString(navigator.language, { hour: 'numeric', minute: '2-digit' });
}

export default function ChatMessage(props: ChatMessageProps) {
	const dispatch = useDispatch();
	const {
		post,
		user: messageUser,
		isChild,
		socket,
	} = props;

	const {watchedProfile} = useProfile({suggestedProfile: messageUser?.gr_user});
	const maskedProfile = watchedProfile || messageUser;
	const host = useSelector((s: GS) => s.SessionReducer.host);
	const user = useSelector((s: GS) => s.SessionReducer.user);

	

	const handleOpenDeleteModal = () => {
		dispatch(ModalActions.setModalState({
			modalOpen: true,
			modalTemplate: MODAL_TEMPLATES.DELETE_CHAT_MESSAGE_CONFIRMATION,
			modalData: {
				chatPost: post,
				socket,
			},
		}));
	};

	const canDelete = useMemo(() => maskedProfile?.gr_user === user?.gr_user || host, [host, user]);

	return (
		<div className="chat-message-container">
			{isChild ? (
				<div className="avatar-spacer"></div>
			) : (
				<>
					{maskedProfile && (
						<Avatar
							user={maskedProfile}
							size="chat"
							noBorder={true}
						/>
					)}
				</>
			)}

			<div className='chat-message'>
				{!isChild && (
					<div className="chat-message-meta">
						<label>{maskedProfile?.first_name} {maskedProfile?.last_name}</label>
						<span>{parseDate(post.created)}</span>
					</div>
				)}

				<div className="chat-message-content">
					<ReactMarkdown
						components={{
							a: (componentProps: any) => <a href={componentProps.href} rel="noopener noreferrer" target="_blank">
									{componentProps.children}
								</a>,
						}}
					>
						{post.message}
					</ReactMarkdown>
				</div>
			</div>
			<div
				className="flex-align-center"
				style={{
					marginLeft: !canDelete ? '32px' : '0px',
					marginBottom: '10px',
				}}
			>
				{canDelete && (
					<div
						className="delete-message"
						onClick={handleOpenDeleteModal}
						data-testid="delete-chat-message"
					>
						<Icon name={ICONS.TRASH} color={COLORS.TEXT_GRAY_300} size={12} />
					</div>
				)}
			</div>
		</div>
	);
}
